module.exports = __webpack_public_path__ + "static/media/betPlace.7e8a9e4d.mp3";